import React from "react";
import {
  Button,
  Dialog as MUIDialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export default function DeleteDialog({
  dialogState,
  setDialogState,
  title,
  description,
  handleAgree,
}) {
  const handleClose = () => {
    setDialogState({
      state: false,
      id: "",
    });
  };

  return (
    <React.Fragment>
      <MUIDialog open={dialogState.state} onClose={handleClose}>
        <DialogTitle style={{ paddingBottom: "4px" }}>{title}</DialogTitle>

        <DialogContent>
          <DialogContentText>{description}</DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              handleAgree();
              handleClose();
            }}
            variant="contained"
            style={{ background: "#d32f2f", color: "#fff" }}
          >
            Delete
          </Button>

          <Button
            onClick={handleClose}
            variant="outlined"
            color="primary"
            autoFocus
          >
            Cancel
          </Button>
        </DialogActions>
      </MUIDialog>
    </React.Fragment>
  );
}
